import { Select as SearchableSelect } from 'chakra-react-select';
import { getRegistrationSelectStyles } from '../utils/chakraSelectStyles';

/**
 * Searchable select tuned for registration forms — light theme only,
 * readable in OS dark mode (menus, chevrons, clear button).
 */
export function RegistrationSearchableSelect({
    isReadOnly,
    isDisabled,
    chakraStyles,
    ...props
}) {
    const readOnly = isReadOnly || isDisabled;

    return (
        <SearchableSelect
            classNamePrefix="registration-select"
            chakraStyles={chakraStyles ?? getRegistrationSelectStyles({ isReadOnly: readOnly })}
            isDisabled={isDisabled}
            isReadOnly={isReadOnly}
            {...props}
        />
    );
}

export default RegistrationSearchableSelect;
